<template>
  <div class="confirm-next-slide connection-lost active">
    <div class="text">
      <span class="spinner-wrapper">
        <span class="loading-spinner black mb--2px" />
      </span>
      <!-- Unstable connection, trying to reconnect... -->
      <span class="ml-1">{{ $t("tryingReconnect") }}</span>
    </div>
    <div>
      <ui-button size="sm" @click="reloadPage" class="border-primary">
        {{ $t("reloadTextLink") }}
      </ui-button>
      <ui-button
        size="sm"
        class="ml-2"
        @click="ignoreReload"
        variant="outline-primary"
      >
        {{ $t("ignoreButton") }}
      </ui-button>
    </div>
  </div>
</template>
<script>
// UI
import UiButton from '@/components/UI/Button'

import Util from '@/util'

export default {
  components: {
    UiButton,
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    reloadPage() {
      window.location.reload()
      Util.gaTrackEvent(
        'System Status',
        'User presses Reload',
        this.$store.state.presentation.id,
        { nonInteraction: true },
      )
    },

    ignoreReload() {
      this.$store.state.socketDisconnect = false
      Util.gaTrackEvent(
        'System Status',
        'User presses Ignore',
        this.$store.state.presentation.id,
        { nonInteraction: true },
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.text {
  margin-bottom: 8px;
}

.loading-spinner {
  width: 0.9em;
  height: 0.9em;
}
</style>
